import { render, staticRenderFns } from "./dash_chanstatus.vue?vue&type=template&id=62dac304&scoped=true&"
import script from "./dash_chanstatus.vue?vue&type=script&lang=js&"
export * from "./dash_chanstatus.vue?vue&type=script&lang=js&"
import style0 from "./dash_chanstatus.vue?vue&type=style&index=0&id=62dac304&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "62dac304",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!/home/nico/Projects/ecopbx-web/node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib'
import { VCardText } from 'vuetify/lib'
import { VFlex } from 'vuetify/lib'
import { VLayout } from 'vuetify/lib'
import { VList } from 'vuetify/lib'
import { VListTile } from 'vuetify/lib'
import { VListTileContent } from 'vuetify/lib'
installComponents(component, {VCard,VCardText,VFlex,VLayout,VList,VListTile,VListTileContent})
